import { useState } from "react";
import DocumentsTab from "./DocumentsTab";
import RecordingsTab from "./RecordingsTab";
import RelatedLinksTab from "./RelatedLinksTab";

function EventTabs({ event }) {
  const [activeTab, setActiveTab] = useState("documents");

  // console.log("EVENT DI TAB:", event);

  return (
    <div className="border-t py-6 my-6">
      {/* TAB HEADER */}
      <div className="flex gap-6 border-b mb-6">
        {[
          { key: "documents", label: "Documents" },
          { key: "recordings", label: "Recordings" },
          { key: "links", label: "Related Link" },
        ].map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`pb-2 border-b-2 text-sm font-medium transition
              ${
                activeTab === tab.key
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* TAB CONTENT */}
      {activeTab === "documents" && (
        <DocumentsTab event={event} />
      )}

      {activeTab === "recordings" && <RecordingsTab event={event}/>}

      {activeTab === "links" && <RelatedLinksTab event={event}/>}
    </div>
  );
}

export default EventTabs;
